var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes},[_c('h2',{staticClass:"h5"},[(_vm.count)?_c('span',{staticClass:"badge badge-pill badge-danger mr-2"},[_vm._v(_vm._s(_vm.count))]):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }